export function getStatusColorsSinister(status: string) {
	switch (status) {
		case "open":
			return { bg: "#FFF3E0", color: "#D97904" }; // laranja suave
		case "in_progress":
			return { bg: "#E6FAF9", color: "#00A6A6" }; // ciano leve
		case "in_analysis":
			return { bg: "#E3F2FD", color: "#1976D2" }; // azul leve
		case "finalized":
			return { bg: "#E8F5E9", color: "#4CAF50" }; // verde leve
		case "pending":
			return { bg: "#FFF9E5", color: "#F2C200" }; // amarelo suave
		case "canceled":
			return { bg: "#FDEAEA", color: "#E53935" }; // vermelho suave
		case "debts_confession":
			return { bg: "#F5F8E7", color: "#9E9D24" }; // oliva
		case "monthly_compensation":
			return { bg: "#E0F7EF", color: "#009688" }; // verde água
		case "lmi_exhaustion":
			return { bg: "#FFECE0", color: "#FF5722" }; // laranja queimado
		case "sketch":
			return { bg: "#E5F6FD", color: "#039BE5" }; // azul leve
		case "according":
			return { bg: "#E8F5E9", color: "#388E3C" }; // verde acordo
		case "preventive":
			return { bg: "#FFF3E0", color: "#FB8C00" }; // laranja preventivo
		case "judicial":
			return { bg: "#F3E5F5", color: "#8E24AA" }; // roxo judicial
		case "extrajudicial":
			return { bg: "#E1F5FE", color: "#0288D1" }; // azul extrajudicial
		default:
			return { bg: "#ECECEC", color: "#757575" }; // cinza padrão
	}
}
